import styled from 'styled-components';

export const VisibilityToggle = styled('div')`
  display: inline-flex;
  justify-content: space-between;
`;